import { useState, useEffect } from 'react';
import { getProjectConfig } from '../utils/api';

/**
 * Загрузка конфигурации проекта (схемы конфликта) с API.
 * @param {number} projectId
 * @returns {{ data: Object|null, loading: boolean, error: string|null }}
 */
export const useProjectConfig = (projectId = 1) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await getProjectConfig(projectId);
        if (!active) return;
        setData({
          blocks: res.blocks,
          first_phrase_screen: res.first_phrase_screen,
          next_phrase_screen: res.next_phrase_screen,
          glossary: res.glossary || {},
        });
      } catch (err) {
        console.error('Failed to load config from API:', err);
        if (active) setError(err.message);
      } finally {
        if (active) setLoading(false);
      }
    };

    load();
    return () => {
      active = false;
    };
  }, [projectId]);

  return { data, loading, error };
};
